import { Component, Input, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzTagModule } from 'ng-zorro-antd/tag';
import { RapiderJsonViewerComponent } from '@rapider/components/json-viewer';
import { RapiderListGridComponent } from '@rapider/list-grid';

import { selectProjectModelsList } from '@rapider/project-data';
import { DataOperationEvent } from '@rapider/ai-chat';
import {
  DATA_INSIGHT_CONFIG,
  generateTimelineGridConfig,
  buildUpdateDiffClassMap,
} from '../database.config';
import { Store } from '@ngrx/store';

/**
 * @class TimelineNodeCardComponent
 * @description A strictly presentation component that maps isolated data events to visually distinct UI blocks.
 * Dynamically switches between simple JSON views and comprehensive data grids depending on array payload size.
 */
/**
 * @class TimelineNodeCardComponent
 * @description A strictly presentation component that maps isolated data events to visually distinct UI blocks.
 * Dynamically switches between simple JSON views and comprehensive data grids depending on array payload size.
 */
@Component({
  selector: 'rapider-timeline-node-card',
  standalone: true,
  imports: [
    CommonModule,
    NzTagModule,
    RapiderJsonViewerComponent,
    RapiderListGridComponent,
  ],
  templateUrl: './timeline-node-card.component.html',
})
export class TimelineNodeCardComponent {
  private readonly store = inject(Store);

  @Input({ required: true }) event!: DataOperationEvent;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data: any[] | null = null;
  @Input() isLoading: boolean = false;

  public readonly config = DATA_INSIGHT_CONFIG;

  /** Resolves the human-readable project model title from the NgRx cache using the event's raw projectModelName. */
  public modelTitle = computed(() => {
    const cachedModels = this.store.selectSignal(selectProjectModelsList)();
    if (!cachedModels || cachedModels.length === 0)
      return this.event.projectModelName;

    const foundModel = cachedModels.find(
      (m: any) =>
        (m.name &&
          m.name.toLowerCase() === this.event.projectModelName.toLowerCase()) ||
        (m.dataTableName &&
          m.dataTableName.toLowerCase() ===
            this.event.projectModelName.toLowerCase()),
    );

    return foundModel?.title || foundModel?.name || this.event.projectModelName;
  });

  /** Computes the data-table list grid mapping cleanly natively on demand without mutating state. */
  public gridConfig = computed(() =>
    generateTimelineGridConfig(this.data || []),
  );

  /** Computes the highlight rules for the JSON viewer if the operation is an UPDATE. */
  public diffClassMap = computed(() => {
    if (this.event.operationType === 'UPDATE' && this.event.payloadData) {
      return buildUpdateDiffClassMap(this.event.payloadData);
    }
    return {};
  });
}
